import { postReverseProposal } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  CreateReverseProposalServiceRequest,
  CreateReverseProposalServiceResponse,
} from './create-reverse-proposal.dto';
import {
  CreateReverseProposalServiceRequestSchema,
  CreateReverseProposalServiceResponseSchema,
} from './create-reverse-proposal.dto';

export const createReverseProposalService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(CreateReverseProposalServiceRequestSchema),
    async (
      request: CreateReverseProposalServiceRequest,
    ): Promise<CreateReverseProposalServiceResponse> => {
      const apiResponse = await postReverseProposal(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '캠페인 역제안 요청에 실패했습니다.');
      }

      return apiResponse.data;
    },
    validateServiceResponse(CreateReverseProposalServiceResponseSchema),
  ),
);
